// extracted by mini-css-extract-plugin
export default {"truckList":"style_truckList__B3oLz","truckEmptyList":"style_truckEmptyList__q8qU1","truckEmptyTitle":"style_truckEmptyTitle__qjBx0"};